<template>
  <div class="grid grid-cols-3 gap-4 items-center">
    <div class="flex">
      <button
        v-if="!hidePrev"
        :disabled="loading"
        class="btn btn-secondary btn-sm"
        @click="handleUpdatePage(+page - 1)"
      >
        Previous
      </button>
    </div>
    <span class="text-center text-sm text-gray-700">{{ paginationText }}</span>
    <div class="flex justify-end">
      <button
        v-if="!hideNext"
        :disabled="loading"
        class="btn btn-secondary btn-sm"
        @click="handleUpdatePage(+page + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({
  name: 'AppPagination',
});

const props = defineProps({
  page: {
    type: [Number, String],
    required: true,
  },
  per_page: {
    type: [Number, String],
    required: true,
  },
  total_pages: {
    type: [Number, String],
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:page']);

const hidePrev = computed(() => !props.loading && props.page <= 1);
const hideNext = computed(() => !props.loading && props.page >= props.total_pages);
const paginationText = computed(() => {
  if (props.loading) return 'Loading...';
  return `Page ${props.page} of ${props.total_pages}`;
});

const handleUpdatePage = (newPage) => {
  const layoutContent = document.getElementById('layout-content');
  layoutContent.scrollTo({ top: 0, behavior: 'smooth' });
  emit('update:page', newPage);
};
</script>
